export default class ExecutionFocusVisit {
  constructor (raw) {
    this.visitId = raw.visit_id
    this.storeId = raw.store_id
    this.storeName = raw.store_name
    this.storeCode = raw.store_code
    this.userId = raw.user_id
    this.userName = raw.user_name
    this.productId = raw.product_id
    this.productName = raw.product_name
    this.submittedAt = raw.submitted_at
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/ExecutionFocusVisit.js